import Header from "./components/Header";
import Hero from "./components/Hero";
import Sobre from "./components/Sobre";
import Servicos from "./components/Servicos";
import WhatsAppForm from "./components/WhatsAppForm";
import Footer from "./components/Footer";

export default function App() {
  return (
    <div className="font-sans text-gray-800">
      <Header />
      <Hero />
      <Sobre />
      <Servicos />
      <WhatsAppForm />
      <Footer />
    </div>
  );
}
